module.exports = __webpack_public_path__ + "static/media/edit.c05370ce.svg";